<script setup>
import SelectionButtonsInput from "@/components/forms/SelectionButtonsInput.vue";
import SelectionButton from "@/components/forms/SelectionButton.vue";
import {HospitalType, HospitalTypeLabel} from "../choices";

const hospitalType = defineModel({type: String});
const props = defineProps({
    fieldProps: {
        type: Object,
    },
});
const emit = defineEmits(['submit']);

function submit() {
    if (!!hospitalType.value) {
        emit('submit', hospitalType.value);
    }
}
</script>

<template>
    <main>
        <h1>{{ pgettext('label', 'Hospital Type') }}</h1>

        <SelectionButtonsInput v-model="hospitalType" v-bind="fieldProps" size="x-large" :height="72" @click="submit()">
            <SelectionButton :value="HospitalType.SPECIALISED" color="red-darken-1">
                <strong>{{ HospitalTypeLabel[HospitalType.SPECIALISED] }}</strong>
            </SelectionButton>
            <SelectionButton :value="HospitalType.GENERAL" color="green-darken-1">
                <strong>{{ HospitalTypeLabel[HospitalType.GENERAL] }}</strong>
            </SelectionButton>
        </SelectionButtonsInput>

        <p v-if="hospitalType" class="text-center mt-4">
            <v-btn color="green" size="large" @click="submit()">
                <strong>{{ pgettext('action', 'Continue') }}</strong>
            </v-btn>
        </p>
        <p v-else class="text-center text-subtitle-2">
            {{ gettext('To continue, please select one of the options.') }}
        </p>
    </main>
</template>
